import { GetterTree } from 'vuex'
import LocationsState from '../../types/LocationsState'
import RootState from '@vue-storefront/core/types/RootState'

const getters: GetterTree<LocationsState, RootState> = {
  getLocations: (state) => state.locations,
  getActiveLocation: state => state.current_location,
  getCurrentLocationMeta: state => {
    const currentLocation = state.current_location;

    if (!currentLocation || !currentLocation.courier_enrollment_meta) {
      return null;
    }

    return currentLocation.courier_enrollment_meta;
  },
  getLocationByCode: state => code => state.locations.find(l => l.code === code)
}

export default getters
